import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { fetchOneEntry } from '@builder.io/sdk-angular';
import { ONEDAY } from '@core/utils/timeConstants';
import { environment } from '@environment/environment';
import { defer } from 'rxjs';
import { CacheService } from './cache.service';

@Injectable({
    providedIn: 'root',
})
export class BuilderIOService {
    private router = inject(Router);
    private cacheService = inject(CacheService);

    private readonly cacheNamespace = 'BuilderIOService';
    builderIOAPIKey = environment.builderIOAPIKey;
    model = 'page';

    constructor() {}

    fetchCurrentPage() {
        const obs = defer(() =>
            fetchOneEntry({
                apiKey: this.builderIOAPIKey,
                model: this.model,
                userAttributes: { urlPath: this.router.url },
            })
        );

        return this.cacheService.cacheWrapper(
            this.cacheNamespace,
            `page_by_url_${this.router.url}`,
            true,
            obs,
            ONEDAY
        );
    }
}
